import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data", "render", "itemRender", "size", "value", "valueName", "onChange", "controlType", "isCardDisabled", "minLength", "maxLength", "cancelable", "className"],
    _excluded2 = ["checked", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from '@jd/jmtd-tools/es/classnames';
import ConfigConsumerProvider from '@jd/jmtd/es/ConfigConsumerProvider';
import React from 'react';
import PropTypes from 'prop-types';
import SummaryCard, { SUMMARY_CARD } from '../SummaryCard';
import BasicSummary from '../BasicSummary';
export default function Summary(_ref) {
  var _data$;

  var data = _ref.data,
      render = _ref.render,
      itemRender = _ref.itemRender,
      size = _ref.size,
      value = _ref.value,
      valueName = _ref.valueName,
      onChange = _ref.onChange,
      controlType = _ref.controlType,
      isCardDisabled = _ref.isCardDisabled,
      minLength = _ref.minLength,
      maxLength = _ref.maxLength,
      cancelable = _ref.cancelable,
      className = _ref.className,
      others = _objectWithoutProperties(_ref, _excluded);

  var grouped = data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.data; // 数据是否是分组的

  var hasLabel = grouped && !!data.find(function (group) {
    return group.label;
  }); // 是否有label

  var summaryCardProps = function summaryCardProps() {
    return {};
  }; // 根据单选、多选，生成指标卡的属性计算函数


  if (controlType === 'checkbox') {
    var _value;

    value = (_value = value) !== null && _value !== void 0 ? _value : [];
    var checkedLength = value.length;
    var checkedSet = new Set(value || []);

    summaryCardProps = function summaryCardProps(_ref2) {
      var itemValue = _ref2[valueName];
      var checked = checkedSet.has(itemValue);
      var disabled = false;

      if (minLength && checked && checkedLength === minLength) {
        disabled = true;
      } else if (maxLength && !checked && checkedLength === maxLength) {
        disabled = true;
      }

      return {
        checked: checked,
        disabled: disabled,
        onChange: checked ? function () {
          onChange(value.filter(function (v) {
            return v !== itemValue;
          }));
        } : function () {
          onChange(value.concat(itemValue));
        }
      };
    };
  } else if (controlType === 'radio') {
    summaryCardProps = function summaryCardProps(_ref3) {
      var itemValue = _ref3[valueName];
      var checked = itemValue === value;
      var onRadioChange;

      if (cancelable) {
        onRadioChange = function onRadioChange() {
          if (checked) {
            onChange(null);
          } else {
            onChange(itemValue);
          }
        };
      } else {
        onRadioChange = checked ? function () {} : function () {
          onChange(itemValue);
        };
      }

      return {
        checked: checked,
        onChange: onRadioChange
      };
    };
  }

  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    size: size
  }, function (_ref4) {
    var configSize = _ref4.size;
    var classNameByItem; // 卡片带来的className，比如图标指标卡有非默认的最小宽度

    var _render = render(_objectSpread({}, others), {
      grouped: grouped,
      hasLabel: hasLabel,
      getItems: function getItems(itemsData) {
        return itemsData.map(function (item) {
          var _summaryCardProps = summaryCardProps(item),
              checked = _summaryCardProps.checked,
              disabled = _summaryCardProps.disabled,
              other = _objectWithoutProperties(_summaryCardProps, _excluded2);

          var children = itemRender(item);
          var propsByCardComponent = children === null || children === void 0 ? void 0 : children.type[SUMMARY_CARD]; // 卡片组件的属性，见IconSummaryCard和ColorSummaryCard

          // 卡片组件的属性，见IconSummaryCard和ColorSummaryCard
          if (propsByCardComponent && !classNameByItem) {
            var _propsByCardComponent;

            classNameByItem = (_propsByCardComponent = propsByCardComponent.summaryClassName) === null || _propsByCardComponent === void 0 ? void 0 : _propsByCardComponent.call(propsByCardComponent);
          }

          return {
            item: item,
            checked: checked,
            children: /*#__PURE__*/React.createElement(SummaryCard, _extends({
              disabled: isCardDisabled(item) || disabled,
              checked: checked,
              controlType: controlType
            }, cardProps(item), other), children)
          };
        });
      }
    }),
        typeClassName = _render.className,
        Component = _render.Component,
        GroupedComponent = _render.GroupedComponent,
        group = _render.group,
        _render$cardProps = _render.cardProps,
        cardProps = _render$cardProps === void 0 ? function () {
      return {};
    } : _render$cardProps,
        getProps = _render.getProps;

    var wrapperClassName = function wrapperClassName() {
      return classNames('jmtp-summary', typeClassName, classNameByItem, {
        'jmtp-summary-small': configSize === 'small' || configSize === 'mini'
      }, className);
    };

    if (group) {
      // 类型允许分组
      if (grouped) {
        // 数据已分组
        var _inner = data.map(function (_ref5, groupIndex) {
          var label = _ref5.label,
              groupData = _ref5.data;
          return /*#__PURE__*/React.createElement(Component, _extends({
            key: groupIndex,
            label: label
          }, getProps(groupData)));
        });

        return /*#__PURE__*/React.createElement(GroupedComponent, {
          "data-component-name": "Summary",
          className: wrapperClassName()
        }, _inner);
      } // 数据未分组


      var inner = /*#__PURE__*/React.createElement(Component, getProps(data));
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassName()
      }, inner);
    } // 类型不允许分组


    var props = getProps(data);
    return /*#__PURE__*/React.createElement(Component, _extends({
      "data-component-name": "Summary",
      className: wrapperClassName()
    }, props));
  });
}
Summary.propTypes = {
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  itemRender: PropTypes.func,
  render: PropTypes.func,
  data: PropTypes.array,
  className: PropTypes.any,
  controlType: PropTypes.string,
  onChange: PropTypes.any,
  value: PropTypes.any,
  isCardDisabled: PropTypes.func,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  valueName: PropTypes.string,
  cancelable: PropTypes.bool
};
Summary.defaultProps = {
  size: null,
  itemRender: function itemRender() {
    return '';
  },
  render: BasicSummary,
  data: [],
  className: null,
  controlType: null,
  onChange: function onChange() {},
  value: null,
  isCardDisabled: function isCardDisabled(item) {
    return item.disabled;
  },
  maxLength: null,
  minLength: null,
  valueName: 'value',
  cancelable: false
};